module.exports = __webpack_public_path__ + "img/pic1.1dd7b81e.jpg";